import styled from 'styled-components';
import { getBadgeColor } from './CardPlay.utils';

export const Wrapper = styled.div`
  font-size: 0.8px;
  width: 320em;
  height: 480em;
  padding: 20em;
  display: flex;
  flex-direction: column;
  background: #333;
  box-shadow: 0 8em 15em rgba(0, 0, 0, 0.5);
  position: relative;
  background: linear-gradient(45deg, #30374877, #000000cc);
  cursor: pointer;
  border: 2px solid rgba(255, 255, 255, 0.1);

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    --grid: rgba(255, 255, 255, 0.05);
    background-size: 20em 20em;
    background-image: linear-gradient(var(--grid) 1em, transparent 1em),
      linear-gradient(90deg, var(--grid) 1em, transparent 1em);
  }

  &:hover {
    border: 2em solid #667;
  }

  &.small {
    font-size: 0.4px;
    height: 430em;

    .image {
      background-size: contain;
    }
  }

  &.small {
    border: 1px solid rgba(255, 255, 255, 0.1);

    .bottom {
      display: none;
    }

    .badge {
      padding: 2px;
    }

    .cost {
      display: none;
    }
  }
`;

export const Top = styled.div`
  text-align: center;
  margin-bottom: 10em;
`;

export const Title = styled.div`
  font-size: 28em;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.7);
  margin: 5px 0 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const By = styled.div`
  font-size: 16em;
  color: #aaa;
`;

export const Center = styled.div`
  flex: 1;
  background: url('path_to_your_image.jpg') center/cover no-repeat;
  border: 1em solid rgba(205, 205, 255, 0.3);
  border-radius: 10em;
  box-shadow: inset 0 4em 8em rgba(0, 0, 0, 0.7);
  margin: 10em 0;
  background: rgba(0, 0, 0, 0.9);
  position: relative;
`;

export const Bottom = styled.div`
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10em;
  padding: 10em;
  box-shadow: inset 0 2em 4em rgba(0, 0, 0, 0.6);
`;

export const Description = styled.div`
  font-size: 14em;
  color: #ccc;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const LevelBadge = styled.div<{ level: 'gold' | 'silver' | 'bronze' }>`
  position: absolute;
  top: 10px;
  right: 10px;
  background: ${(props) => getBadgeColor(props.level)};
  color: rgba(0, 0, 0, 0.8);
  padding: 5px 10px;
  border-radius: 5em;
  font-weight: bold;
  font-size: 14em;
  text-transform: uppercase;
`;

export const TagSection = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10em;
  flex-wrap: wrap;
`;

export const Tag = styled.div`
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  padding: 4em 8em;
  border-radius: 5em;
  font-size: 12em;
  margin: 2em;
`;

export const Video = styled.video`
  object-fit: cover;
  height: 100em;
  position: absolute;
  left: -30em;
  right: 0;
  max-width: 300em;
  max-height: 250em;
  filter: brightness(1.2);
  border: none;
  outline: none;
  background: transparent;
  box-shadow: none;
`;

export const Image = styled.div`
  width: 270em;
  height: 240em;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
`;

export const Points = styled.div`
  position: absolute;
  right: -2px;
  bottom: 24%;
`;
